<template>
    <!--
        latestImageIdとunsavedPuriCountはこのheader,footerタイプの組み合わせだと必要ないが
        BaseLayoutの設計上必須propsにしているので、ダミーの値を渡している
    -->
    <base-layout
        :header-type="headerType.LOGOONLY"
        :footer-type="footerType.COPYRIGHTONLY"
        latest-image-id="dummy"
        unsaved-puri-count="0"
    >
        <div class="c-jhs-free-completed">
            <jhs-free-heading />
            <section class="c-jhs-free-completed-section01">
                <heading-bg title="申込完了"/>
                <div class="l-element">
                    <p class="m-text-normal is-primary is-text-center is-text-bold is-mgb0">審査を開始するよ！</p>
                    <img class="c-jhs-free-completed-section01-img" :src="buildImageUrl('/img/jhs_free/done.svg')" alt="DONE">
                    <div class="l-element">
                        <p class="m-text-normal">
                            お申し込みありがとうございました。申込完了メールをお送りしましたのでご確認ください。<br>
                        </p>
                        <link-text class="m-text-comments is-caution" :link="helpDetailLink" text="※申込完了メールが届かない場合" :new-window="true" data-jest="help-link"/>
                    </div>
                </div>
            </section>

            <section class="c-jhs-free-completed-section02">
                <heading-bg title="審査結果の通知"/>
                <div class="l-element">
                    <p class="m-text-normal">審査結果は<span class="is-primary is-text-bold">最短15分〜通常1時間</span>以内に出ます。</p>
                    <p class="m-text-comments is-light">※やむを得ない事情で５日以上かかる場合もございます。</p>
                </div>
                <heading-horizon text="審査結果の確認方法" />
                <div class="l-element">
                    <list-text :decimal="true">
                        <li class="m-list-text-item is-text-bold">
                            メールでのご連絡
                            <p class="m-text-normal">
                                <span class="is-primary">sp-pictlink@pictlink.com</span>より申込時の入力メールアドレスにお送りします。
                            </p>
                            <p class="m-text-comments is-light">
                                ※入力メールアドレス間違いや容量オーバーでお届けできないことがございます。<br>
                                その場合は、ピクトリンク内でご確認頂けますようお願い申し上げます。
                            </p>
                        </li>
                        <li class="m-list-text-item is-text-bold">
                            ピクトリンク内でのご連絡
                            <p class="m-text-normal">
                                <span class="is-primary">お申込み時のアカウントでログイン状態</span>の場合にサイトとアプリに表示されます。
                            </p>
                        </li>
                    </list-text>
                </div>
            </section>

            <section v-if=isAppli class="c-jhs-free-completed-section03" data-jest="c-jhs-free-completed-section03-appli">
                <heading-bg title="表示場所"/>
                <div class="l-element">
                    <p class="m-text-normal is-text-center is-mgb16">アプリ版ピクトリンク</p>
                    <img class="c-jhs-free-completed-section03-img" :src="buildImageUrl('/img/jhs_free/completed/img_done_notice_app.png')" alt="アプリ版ピクトリンク表示場所イメージ">
                </div>
                <div class="l-element">
                    <p class="m-text-normal is-text-center is-mgb16">サイト版ピクトリンク</p>
                    <img class="c-jhs-free-completed-section03-img" :src="buildImageUrl('/img/jhs_free/completed/img_done_notice_site.png')" alt="サイト版ピクトリンク表示場所イメージ">
                </div>
            </section>

            <section v-else class="c-jhs-free-completed-section03" data-jest="c-jhs-free-completed-section03-web">
                <heading-bg title="表示場所"/>
                <div class="l-element">
                    <p class="m-text-normal is-text-center is-mgb16">サイト版ピクトリンク</p>
                    <img class="c-jhs-free-completed-section03-img" :src="buildImageUrl('/img/jhs_free/completed/img_done_notice_site.png')" alt="サイト版ピクトリンク表示場所イメージ">
                </div>
                <div class="l-element">
                    <p class="m-text-normal is-text-center is-mgb16">アプリ版ピクトリンク</p>
                    <img class="c-jhs-free-completed-section03-img" :src="buildImageUrl('/img/jhs_free/completed/img_done_notice_app.png')" alt="アプリ版ピクトリンク表示場所イメージ">
                </div>
            </section>
            <div class="l-element">
                <btn @click="onClickTopButton" :priority="cssPriority.SECONDARY" text="ピクトリンクTOPへ" data-jest="top-link"/>
            </div>
        </div>
    </base-layout>
</template>

<script>
import BaseLayout from "../../templates/BaseLayout.vue";
import JhsFreeHeading from "../../molecules/JhsFreeHeading.vue";
import HeadingBg from "../../atoms/HeadingBg.vue";
import ListText from "../../atoms/ListText.vue";
import Btn from "../../atoms/Btn.vue"
import LinkText from "../../atoms/LinkText.vue"
import * as metaInformationUtil from "../../../util/metaInformationUtil.js";
import * as urlUtil from "../../../util/UrlUtil.js";
import {cssPriority} from "../../../view-model/enum/CSSPriority";
import HeadingHorizon from "../../atoms/HeadingHorizon.vue";
import {headerType} from "../../../view-model/enum/HeaderType";
import {footerType} from "../../../view-model/enum/FooterType";
import {mapGetters} from "vuex";
import {moveToTopPage} from "./common/jhsFreeLinkUtils";

export default {
    name: "JhsFreeCompleted",
    components: {BaseLayout, HeadingHorizon, JhsFreeHeading, HeadingBg, ListText, Btn, LinkText},
    props: {
        /**
         * titleタグ
         */
        title: {
            type: String,
            required: true
        },
        /**
         * meta description
         */
        description: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            headerType: headerType,
            footerType: footerType,
            cssPriority: cssPriority,
            helpDetailLink: urlUtil.helpUrlUtil.helpDetailUrl("1841"),
        }
    },
    computed:{
        ...mapGetters('AccountStoreV2', [
            'isAppli'
        ]),
    },
    methods: {
        setTitleAndDesc() {
            metaInformationUtil.setTitleAndDescription(this.title, this.description)
        },
        /*
         * VOYAGERFRONT-6111 LINEイベントコード設置
         * ユニテのため切り出している
         */
        sendLineTag() {
            _lt('send', 'cv', {
                type: 'event4'
            },['00959236-1b74-4654-8bc6-3b291d37ee67']);
        },
        onClickTopButton(){
            moveToTopPage(this.isAppli,'ピクトリンクTOPへ')
        },
        buildImageUrl(url)  {
            return urlUtil.imageUrlUtil.buildImageUrl(url)
        }
    },
    mounted() {
        this.setTitleAndDesc()

        // 広告タグ送信
        this.sendLineTag();
    }
}
</script>

<style scoped lang="scss">
    @use "sass:math";
    // 基本の余白
    $grid-base: 4.27vw; // 375px幅に対して16px
    $grid-consistent: $grid-base * 0.5;// 375px幅に対して8px
    .c-jhs-free-completed {
        margin-bottom: $grid-base * 2;
        &-section01 {
            &-img {
                display: block;
                width: percentage(math.div(88px, 343px));
                margin: 0 auto $grid-consistent;
            }
         }
        &-section02 {
            padding: $grid-consistent $grid-consistent 0;
            .m-text-comments {
                font-weight: normal;
            }
        }
        &-section03 {
            &-img {
                display: block;
                width: percentage(math.div(220px, 343px));
                margin: 0 auto $grid-consistent;
            }
        }
    }
</style>
